import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {DirectoryItemComponent} from './directory-item.component';

import {FieldsModule} from '../../components/fields/fields.module';
import {CreateModalModule} from '../../components/directory/create-modal/create-modal.module';

import {InfoComponent} from './info/info.component';
import {ResidentsComponent} from './residents/residents.component';
import {ParkingSpotsComponent} from './parking-spots/parking-spots.component';
import {LockersComponent} from './lockers/lockers.component';
import {VehiclesComponent} from './vehicles/vehicles.component';
import {PetsComponent} from './pets/pets.component';
import {BikeRacksComponent} from './bike-racks/bike-racks.component';
import {ItemActivityComponent} from './activity/activity.component';
import {CommonComponentsModule} from '../../common-components.module';
import {MoveOutModalModule} from '../../components/directory/move-out-modal/move-out-modal.module';
import {SendInvitationModalModule} from '../../components/directory/send-invitation-modal/send-invitation-modal.module';
import {AdminModule} from '../admin/admin.module';
import {ChangeUnitModalModule} from '../../components/directory/change-unit-modal/change-unit-modal.module';
import {AddInstructionsModalModule} from '../../components/directory/add-instructions-modal/add-instructions-modal.module';
import {AmenitiesModule} from '../amenities/amenities.module';
import {ParkingPassModule} from '../parking-pass/parking-pass.module';
import {AccountBalanceModalModule} from '../../components/directory/account-balance-modal/account-balance-modal.module';
import {CaptureImageModalModule} from '../../components/directory/capture-image-modal/capture-image-modal.module';
import {SendSmsModalModule} from '../../components/directory/send-sms-modal/send-sms-modal.module';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        RouterModule,
        FieldsModule,
        CreateModalModule,
        CommonComponentsModule,
        MoveOutModalModule,
        SendInvitationModalModule,
        AdminModule,
        ChangeUnitModalModule,
        AmenitiesModule,
        ParkingPassModule,
        AddInstructionsModalModule,
        AccountBalanceModalModule,
        CaptureImageModalModule,
        SendSmsModalModule
    ],
    declarations: [
        DirectoryItemComponent,
        InfoComponent,
        ResidentsComponent,
        ParkingSpotsComponent,
        LockersComponent,
        VehiclesComponent,
        PetsComponent,
        BikeRacksComponent,
        ItemActivityComponent
    ],
    providers: [],
})
export class DirectoryItemModule {
}



// WEBPACK FOOTER //
// /app/src/app/views/directory-item/directory-item.module.ts